module.exports = __webpack_public_path__ + "static/media/23.6ed6d4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/23.png
// module id = 526
// module chunks = 0